import TaskEditableTitle from "src/components/tasks/TaskEditableTitle";

const TaskModalHead = () => {
	return (
		<div className="flex-1 md:min-h-[40px] max-h-full">
			<TaskEditableTitle variant="medium" autoFocus />
		</div>
	);
};

export default TaskModalHead;
